module.exports = __webpack_public_path__ + "img/hp-case-upgrade-comfort-reference.3b035d5f.png";